import styled from 'styled-components';

import colors from 'theme/colors';

export const ContentStyled = styled.div`
  .ant-tabs-content {
    display: inline-block;
  }

  .ant-table-column-sorters {
    font-weight: bold;
  }

  .ant-tabs-tab:first-child {
    display: none;
  }
  .pagination-contract-list {
    margin-top: 16px;
    width: 100%;
    justify-content: center;
  }
  .ant-table-thead > tr > th {
    background: ${colors.darkestGray};
    font-weight: bold;
  }

  .ContractTermsTable {
    padding-left: 32px;
  }

  .ContractTermsTable .ant-table-thead > tr > th {
    font-weight: bold;
  }
  .ContractTermsTable .ant-table-tbody > tr > td {
    background: ${colors.darkGray};
  }

  tr.ant-table-expanded-row > td,
  tr.ant-table-expanded-row:hover > td {
    background: white;
  }

  .expand-all-rows {
    position: relative;
  }
  .expand-all-rows-btn {
    position: absolute;
    top: 2px;
    padding: 16px;
    z-index: 1;
  }
`;
